import { COUNTERS_LAMBDA_URL, GAMES_URL } from '@/constants/config';
import { getGameApiHeaders } from '../utils/gameUtils';
import { encodeQuery } from '~/modules/common/utils/routingUtils';
const gamesApi = `${GAMES_URL}/v1`;

export const gameService = (http, cookies) => ({
  async addReaction(gameId, reactionId) {
    const { data } = await http.$get(`${COUNTERS_LAMBDA_URL}/hit?key=game:${gameId}:reaction:${reactionId}`, {
      withCredentials: true,
      credentials: 'include',
    });
    return { data };
  },

  async removeReaction(gameId, reactionId) {
    const { data } = await http.$get(`${COUNTERS_LAMBDA_URL}/pop?key=game:${gameId}:reaction:${reactionId}`, {
      withCredentials: true,
      credentials: 'include',
    });
    return { data };
  },

  /**
   * Get player status
   * @param {string} playerId playerId
   * @param {string} gameType gameType
   * @param {string} gameId gameId
   */
  async getPlayerStatus({ playerId, gameType, gameId }) {
    const headers = getGameApiHeaders(cookies);
    const { data } = await http.$get(`${gamesApi}/players/${playerId}/statuses/${gameType}/${gameId}`, { headers });
    return { data };
  },

  /**
   * Add player status
   */
  async addPlayerStatus(params) {
    const headers = getGameApiHeaders(cookies);
    const { data } = await http.$post(`${gamesApi}/players/me/status`, params, {
      headers,
    });
    return { data };
  },

  /**
   * Get daily question
   * @param {string} gameType gameType
   * @param {string} playerId playerId
   * @param {boolean} withStatuses withStatuses
   * @param {boolean} forceCache forceCache
   */
  async getDailyQuestion({ gameType, playerId, withStatuses, forceCache }) {
    const queryParams = encodeQuery({ playerId, withStatuses, forceCache });
    const headers = getGameApiHeaders(cookies);
    const { data } = await http.$get(`${gamesApi}/games/${gameType}/daily-question/${queryParams}`, { headers });
    return { data };
  },

  /**
   * Get game by id
   * @param {string} gameType gameType
   * @param {string} gameId gameId
   * @param {string} playerId playerId
   * @param {boolean} withStatuses withStatuses
   */
  async getGameById({ gameType, gameId, playerId, withStatuses }) {
    const queryParams = encodeQuery({ playerId, withStatuses });
    const headers = getGameApiHeaders(cookies);
    const { data } = await http.$get(`${gamesApi}/games/${gameType}/questions/${gameId}/${queryParams}`, {
      headers,
    });
    return { data };
  },

  /**
   * List games monthly
   * @param {string} gameType gameType
   * @param {string} playerId playerId
   * @param {boolean} withStatuses withStatuses
   * @param {number} year year
   * @param {number} month month
   */
  async listGamesMonthly({ gameType, playerId, withStatuses, year, month }) {
    const headers = getGameApiHeaders(cookies);
    const queryParams = encodeQuery({ playerId, withStatuses, year, month });
    const { data } = await http.$get(`${gamesApi}/games/${gameType}/questions/${queryParams}`, { headers });
    return { data };
  },

  /**
   * Get leaderboard
   * @param {string} boardType boardType
   * @param {string} duration duration
   * @param {string} playerId playerId
   * @param {number} page page
   * @param {number} limit limit
   */
  async getLeaderboard({ boardType, duration, playerId, page, limit }) {
    const queryParams = encodeQuery({ playerId, page, limit });
    const { data, extraData, pagination } = await http.$get(`${gamesApi}/leaderboards/${boardType}/${duration}${queryParams}`);
    return { data, extraData, pagination };
  },

  /**
   * Get leaderboard
   * @param {string} boardType boardType
   * @param {string} duration duration
   * @param {string} playerId playerId
   */
  async getPlayerRank({ boardType, duration, playerId }) {
    const { data } = await http.$get(`${gamesApi}/leaderboards/${boardType}/${duration}/players/${playerId}`);
    return { data };
  },

  /**
   * Get previous games
   * @param {string} gameType gameType
   * @param {boolean} withStatuses withStatuses
   * @param {number} beforeTsInMs beforeTsInMs
   */
  async getPreviousGames({ gameType, withStatuses, beforeTsInMs }) {
    const headers = getGameApiHeaders(cookies);
    const queryParams = encodeQuery({ withStatuses, beforeTsInMs });

    const { data } = await http.$get(`${gamesApi}/games/${gameType}/questions/previous${queryParams}`, { headers });
    return { data };
  },
});
